export const stickyShoppingCartOffset = {
  OFFSET_BUFFER: 120,
  MARGIN_BUFFER: 16
};
